export const arrayToKeyValue = <T extends object>(array: T[], key: keyof T): Record<string, T> => {
    const res: Record<string, T> = {};

    array.forEach((row) => {
        res[String(row[key])] = row;
    });

    return res;
};

export const indexOfObject = <T>(obj: T[], callback: (o: T) => boolean) => {
    let idxOf = -1;

    obj.forEach((val, idx) => {
        if (callback(val)) {
            idxOf = idx;
        }
    });

    return idxOf;
};
